<template>
    <vue-recaptcha
        v-if="loaded"
        class="g-recaptcha"
        :sitekey="captchaKey"
        ref="vueRecaptcha"
        :id="id"
        @verify="validateRecaptcha"
        @expired="onCaptchaExpired"
    />
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import { mapGetters } from 'vuex';

export default {
    name: 'trimoz-recaptcha',
    components: { VueRecaptcha },
    props: {
        id: { type: String, required: false, default: 'recaptcha' },
    },
    computed: {
        ...mapGetters({
            captchaKey: 'captchaKey',
        }),
    },
    data() {
        return {
            loaded: false,
            timeout: null,
        };
    },
    mounted() {
        this.loaded = true;
    },
    beforeDestroy() {
        this.loaded = false;
        clearTimeout(this.timeout);
    },
    methods: {
        reset() {
            this.$refs.vueRecaptcha.reset();

            // 05.03.21
            // It seems changing lg many times breaks recaptcha functionality. A possible workaround is to mount/unmount component
            // so we always get a 'fresh' recaptcha instance on each lg change. Sometimes this can cause an exception (that wont break app, open issue: https://bit.ly/3kPPQRO)
            this.loaded = false;
            this.timeout = setTimeout(() => { this.loaded = true; }, 250);
        },
        /**
         * Validate recaptcha response
         */
        validateRecaptcha(response) {
            this.$emit('onCaptchaAcquired', response);
        },

        /**
         * Reset recaptcha when expired
         */
        onCaptchaExpired() {
            this.$emit('onCaptchaAcquired', '');
            this.$emit('onCaptchaExpired');
        },
    },
};
</script>
